import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getPassengersForSelection, setPassengerSelect } from '@entities/exchange';
import { CdnIcon } from '@shared/ui';

import { ExchangeRefundContentWrapper, ExchangeRefundPassengers } from '@entities/order';
import { ExchangeControlsWrapper } from '@features/exchange/exchange-route-controls/ui';

const Passengers: React.FC = () => {
	const { t } = useTranslation('Exchange');

	const dispatch = useDispatch();

	const passengers = useSelector(getPassengersForSelection);

	const onChangeSelect = (ids: string[], selected: boolean) => {
		dispatch(setPassengerSelect({ id: ids, selected }));
	};

	return (
		<ExchangeRefundContentWrapper width="sm" icon={<CdnIcon icon="Info/Passenger" />} title={t('Passengers.Title')}>
			<ExchangeControlsWrapper>
				<ExchangeRefundPassengers
					passengers={passengers.map(passenger => ({
						ids: passenger.ids,
						label: passenger.label,
						isSelected: passenger.isSelected
					}))}
					onSelect={onChangeSelect}
				/>
			</ExchangeControlsWrapper>
		</ExchangeRefundContentWrapper>
	);
};

export default Passengers;
